import { render } from "./CoBrandVault.vue?vue&type=template&id=2d4d1a42&scoped=true"
import script from "./CoBrandVault.vue?vue&type=script&lang=js"
export * from "./CoBrandVault.vue?vue&type=script&lang=js"

import "./CoBrandVault.vue?vue&type=style&index=0&id=2d4d1a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4d1a42"]])

export default __exports__